import { MessageCircle, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const EmptyConversationState = () => (
  <div className="flex flex-1 items-center justify-center bg-slate-50/50 dark:bg-slate-950/30">
    <div className="mx-auto max-w-md p-8 text-center">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 dark:bg-slate-800 text-slate-400 dark:text-slate-500 shadow-inner">
        <MessageCircle className="h-7 w-7" />
      </div>
      <h3 className="mb-1.5 text-base font-bold text-slate-800 dark:text-slate-200">No conversation selected</h3>
      <p className="mb-5 text-xs text-slate-500 dark:text-slate-400 max-w-xs mx-auto font-medium">
        Choose a conversation from the list to start messaging with your customers.
      </p>
      <Button className="h-9 px-5 text-sm font-semibold rounded-xl shadow-xs gap-1.5">
        <Plus className="h-4 w-4" />
        Start New Conversation
      </Button>
    </div>
  </div>
);

export const EmptyConversationsState = () => (
  <div className="flex items-center justify-center p-8">
    <div className="text-center">
      <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-100 dark:bg-slate-800 text-slate-400 dark:text-slate-500 shadow-inner">
        <MessageCircle className="h-6 w-6" />
      </div>
      <h3 className="mb-1 text-xs font-bold text-slate-800 dark:text-slate-200">No conversations yet</h3>
      <p className="text-[11px] text-slate-400 dark:text-slate-500 font-medium max-w-[200px] mx-auto leading-relaxed">
        Conversations will appear here when customers message you.
      </p>
    </div>
  </div>
);

export const EmptyMessagesState = () => (
  <div className="flex flex-1 items-center justify-center">
    <div className="text-center">
      <MessageCircle className="mx-auto mb-2 h-7 w-7 text-muted-foreground/60" />
      <p className="text-sm text-muted-foreground">Start of conversation</p>
    </div>
  </div>
);
